<template>
  <div class="step-progress">
    <div v-for="step in steps" :key="step.number" class="step-container">
      <div class="step">step {{step.number}}: {{step.title}}</div>
      <div :class="['current-step', { show: step.number === currentStep && !step.isComplete }]">
        <svg class="leaf-icon" viewBox="0 0 425 425">
          <use xlink:href="#leaf-icon"></use>
        </svg>
      </div>
      <div v-if="step.isComplete" :class="['complete', { show: step.isComplete }]">
        <div>complete</div>
        <div :class="['link', `edit-step-${step.number}`]" @click="sendStep(step.number)">edit</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      currentStep: Number,
      steps: Array,
    },

    name: 'StepProgress',

    methods: {
      sendStep(step) {
        this.$emit('validateStep', step)
      }
    }
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.step-progress
  background: $primary-transparent
  display: flex

.step-container
  border-right: 1px solid $primary-color
  flex-basis: 25%
  font-size: 1.25rem
  padding: 1rem
  text-align: center
  @media only screen and (max-width: 40em)
    font-size: .8rem
  &:last-child
    border-right: none

.step
  color: $negative-color
  margin-bottom: 1rem

.complete, .current-step
  color: $title-color
  display: none
  flex-direction: column
  font-weight: bold
  justify-content: center
  &.show
    display: inline-flex
    opacity: 1

svg.leaf-icon
  fill: $primary-color
  height: 50px
  width: 50px
  @media only screen and (max-width: 40em)
    height: 30px
    width: 30px

.link
  cursor: pointer
  margin-top: 1rem
  @media only screen and (max-width: 40em)
    margin-top: .5rem
</style>